//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import StockInventoryTools from './StockInventoryTools.vue'

export default {
  components: {
    StockInventoryTools
  },
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  computed: {
    toolRecords: function () {
      return this.record.request.toolRecords || []
    },
    propertyConfig: function () {
      return this.record.requestProperties.toolRecords
    },
    rules: function () {
      return [() => this.propertyConfig.validateFn(this.toolRecords)]
    }
  },
  methods: {
    validate () {
      return this.$refs.fieldTools.validate()
    }
  }
}

